__turbopack_context__.v({
  "privacyPolicy": "EmailCapture-module-scss-module__1hIr6G__privacyPolicy",
});
